import React from 'react'
import {useTranslation} from 'react-i18next'

export type OrderIntakeErrorType =
  | 'noJobSiteId'
  | 'noJobSiteData'
  | 'optionsLoadFailed'
  | 'noRequiredData'
  | 'noContracts'
  | 'customerNotFound'

interface OrderIntakeErrorStateProps {
  type: OrderIntakeErrorType
}

export const OrderIntakeErrorState: React.FC<OrderIntakeErrorStateProps> = ({type}) => {
  const {t} = useTranslation()

  const errorMessages: Record<OrderIntakeErrorType, {primary: string; secondary: string}> = {
    noJobSiteId: {
      primary: t('orderIntake.rmc.errors.jobSiteIdNotProvided'),
      secondary: t('orderIntake.rmc.errors.pleaseSelectJobSite')
    },
    noJobSiteData: {
      primary: t('orderIntake.rmc.errors.jobSiteDataNotAvailable'),
      secondary: t('orderIntake.rmc.errors.pleaseSelectJobSiteFromModal')
    },
    optionsLoadFailed: {
      primary: t('orderIntake.rmc.errors.failedToLoadOptions'),
      secondary: t('orderIntake.rmc.errors.pleaseRetryLater')
    },
    noRequiredData: {
      primary: t('orderIntake.rmc.errors.unableToLoadRequiredData'),
      secondary: t('orderIntake.rmc.errors.pleaseContactSupport')
    },
    noContracts: {
      primary: t('orderIntake.rmc.errors.noContractsAvailable'),
      secondary: t('orderIntake.rmc.errors.pleaseSelectDifferentJobSite')
    },
    customerNotFound: {
      primary: t('orderIntake.rmc.errors.customerNotFound'),
      secondary: t('orderIntake.rmc.errors.pleaseContactSupport')
    }
  }

  const messages = errorMessages[type]

  return (
    <div style={{padding: '2rem', textAlign: 'center'}}>
      <p>{messages.primary}</p>
      <p>{messages.secondary}</p>
    </div>
  )
}
